import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Neonatologist icon
 *
 * @category Medical
 */
const Neonatologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M16.435 3.098c9.51.94 7.69 10.33 7.76 17.26-.29 12.58-17.92 10.76-16.5-1.38.27-3.92-.74-8.2 1.1-11.77 1.46-2.62 4.46-4.27 7.48-4.11zm6.63 12.66c-.25.08-.68.64-.87.92-2.16 3.33-5.8 5.64-9.95 5.9-.96.12-2.66-.22-2.88 1.06 1.03 5.09 8.94 5.97 12.06 2.19 2.32-2.45 1.92-5.87 1.93-9 0-.65-.08-1.06-.22-1.07zm-7.57-11.67c-3.9.04-7.17 3.95-6.79 7.76-.01 2.81-.17 6.4.07 8.74.07.49.48.78.97.89 7.15 1.43 14.59-5.38 13.11-12.54-.93-2.96-4.11-5.05-7.2-4.84h-.16zm.26 1.26c.03.2-.03.64.17.85.2.23.53.29.83.34 5.42.93 6.16 8.79.86 10.54-6.55 2.03-9.65-7.14-3.81-10.23.45-.25.71-.62.93-.98.21-.33.58-.93.99-.64l.03.11zm.05 2.27c-5.5.18-5.36 8.69.2 8.6 5.69-.14 5.55-8.54-.08-8.6h-.13zm-1.55 4.3c.33 0 .59.26.59.59s-.26.59-.59.59-.59-.26-.59-.59.26-.59.59-.59m3.53 0c.33 0 .59.26.59.59s-.26.59-.59.59-.59-.26-.59-.59.26-.59.59-.59"
        />
      </svg>
    );
  }
);

Neonatologist.displayName = 'Neonatologist';

export { Neonatologist };
